import React from 'react';
import { useTranslation } from 'react-i18next';
import WarningAlertComponent from '../../WarningAlert.component';
import { ChildAlertProps } from '../../BaseAlert.component';

const LastRecordRemoveAlertComponent = ({ handleConfirm }: ChildAlertProps) => {
    const { t } = useTranslation();

    return (
        <WarningAlertComponent onClose={handleConfirm}>
            {t('candidateLastRecordWillBeRemoved')}
        </WarningAlertComponent>
    );
};

export default LastRecordRemoveAlertComponent;
